import React, { useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Accordion from '@material-ui/core/Accordion'
import AccordionSummary from '@material-ui/core/AccordionSummary'
import AccordionDetails from '@material-ui/core/AccordionDetails'
import Typography from '@material-ui/core/Typography'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import ReportTemplate from './ReportTemplate'
import WeatherTemplate from './WeatherTemplate'
import { getReportSettings } from 'utils/ProjectConfigurationUtil'
import { useAppContext } from 'hooks/useAppContext'
import { FormProvider } from 'context/FormContext'

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        fontWeight: theme.typography.fontWeightRegular,
    },
}));

const ReportSettings = () => {
    const { selectedProject } = useAppContext()

    const classes = useStyles()
    const [defaultValues, setDefaultValues] = React.useState()
    const [updateDate, setUpdateDate] = React.useState(new Date());
    const [expanded, setExpanded] = React.useState('panel1');

    const handleChange = (panel) => (event, newExpanded) => {
        setExpanded(newExpanded ? panel : false);
    };

    useEffect(() => {
            getReportSettings(selectedProject).then(data => {
                setDefaultValues(data.data[0]);
            })
    }, [updateDate, selectedProject])

    return (
        <div>
            <Accordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                >
                    <Typography className={classes.heading}>Report Template</Typography>
                </AccordionSummary>
                {defaultValues &&
                    <AccordionDetails>
                        <div style={{ width: '100%' }}>
                        {expanded === 'panel1' && <FormProvider><ReportTemplate CRUDType="UPDATE" defaultValues={defaultValues} callback={() => setUpdateDate(new Date())}/></FormProvider> }
                        </div>
                    </AccordionDetails>
                }
            </Accordion>
            <Accordion expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel2a-content"
                    id="panel2a-header"
                >
                    <Typography className={classes.heading}>Weather Template</Typography>
                </AccordionSummary>
                {defaultValues &&
                    <AccordionDetails>
                        <div style={{ width: '100%' }}>
                            {expanded === 'panel2' && <FormProvider><WeatherTemplate CRUDType="UPDATE" defaultValues={defaultValues} callback={() => setUpdateDate(new Date())}/></FormProvider> }
                        </div>
                    </AccordionDetails>
                }
            </Accordion>
        </div>
    )
}

export default ReportSettings
